"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var response_count_html_1 = __importDefault(require("./response-count.html"));
require("./response-count.less");
var filter_utils_1 = require("@shared/utils/filter-utils");
(function (module) {
    'use strict';
    function ResponseCountController(responseCount, activeReport, eventService, filterUtils) {
        var $ctrl = this;
        var totalResponseCount = 0;
        updateResponseCount();
        eventService.on('responseCountChanged', updateResponseCount);
        angular.extend($ctrl, {
            getResponseCount: function () {
                return totalResponseCount.toLocaleString();
            }
        });
        function updateResponseCount(event, data) {
            var filters = activeReport.getMetadata('filters');
            filters = _.cloneDeep(filters);
            _.forEach(filters, function (filter) {
                filterUtils.fixDateFilters(filter);
                filter_utils_1.fixOldPRFilters(filter);
            });
            var fetchFilterOptions = _.pick(data, ['skipFetchingFilters']);
            responseCount.getTotalResponseCount(filters, fetchFilterOptions).then(function (count) {
                totalResponseCount = count;
            });
        }
    }
    ResponseCountController.$inject = ['prResponseCount',
        'prActiveReport',
        'prEventService',
        'prFilterUtils'
    ];
    module.component('prResponseCountComponent', {
        templateUrl: response_count_html_1.default,
        controller: ResponseCountController
    });
})(angular.module('qualtrics.pr'));
